/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    strong: "strong",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Privacy"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.strong, {
        children: "Eufemia Design System"
      }), " and the ", _jsx(_components.strong, {
        children: "Eufemia Theme Manager"
      }), " do not collect any sort of personal or environmental data."]
    }), "\n", _jsxs(_components.p, {
      children: ["Use everything related to these mentioned tools by your own risks and within the ", _jsx(_components.a, {
        href: "/license",
        children: "license"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
